import { useEffect, useRef } from "react";
import "./LoginModal.css";
import { QRCodeCanvas } from "qrcode.react";
import Icons from "../Common/IconsGroup";
import APP_LINKS from "../assets/AppLinks";

const { APP_STORE_URL, PLAY_STORE_URL, WEB_URL } = APP_LINKS;

const APP_LINKS_DETAILS = [
  {
    name: "Web App",
    info: "Open in your browsers",
    icon: Icons(30, 30).internet(),
    url: WEB_URL
  },
  {
    name: "Android App",
    info: "Get it on Google Play",
    icon: Icons(30, 30).playstore(),
    url: PLAY_STORE_URL
  },
  {
    name: "iOS App",
    info: "Download from App Store",
    icon: Icons(30, 30).appStore(),
    url: APP_STORE_URL
  }
]

const LoginModal = ({
  isMouseEventEnabled,
  SetLoginModel
}) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleMouseDown = (event) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target)
      ) {
        SetLoginModel("SET_WEB_MODEL");
      }
    };

    if(isMouseEventEnabled) {
      document.addEventListener("mousedown", handleMouseDown);
    };

    return () => {
      document.removeEventListener("mousedown", handleMouseDown);
    };
  }, [isMouseEventEnabled, SetLoginModel]);
  

  return (
    <div className="login_modal-overlay" ref={modalRef}>
      <div className="login_modal-content-container">
        <div className="login_modal-header">Access Kompress.Ai</div>
        <div className="login_modal-content-colum">
          <div className="login_modal-links-container">
            {
              APP_LINKS_DETAILS.map((data) => {
                const { info, name, icon, url} = data;
                return (
                  <div
                  onClick={() => window.location.href = url}
                  className="login_modal-links-content-container">
                    <div className="login_modal-links-icon-container">
                      {icon}
                    </div>
                    <div className="login_modal-links-contents">
                      <span className="login_modal-links-header">{name}</span>
                      <span className="login_modal-links-sub-header">{info}</span>
                    </div>
                  </div>
                )
              })
            }
          </div>
          <div className="login_modal-qr-contents">
            <span className="login_modal-qr-header">Scan to download</span>
            <div className="login_modal-qr">
              <QRCodeCanvas
                value={`${window.location.origin}/download`}
                level="H"
                includeMargin
              />
            </div>
            <span className="login_modal-qr-sub-header">Web.Android.iOS</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;